import {
  SPECILITY_BY_ID_REQUEST,
  SPECILITY_BY_ID_SUCCESS,
  SPECILITY_BY_ID_ERROR,
  UPDATE_REQUEST,
  UPDATE_SUCCESS,
  UPDATE_ERROR,
  EMAIL_UPDATE_REQUEST,
  EMAIL_UPDATE_SUCCESS,
  EMAIL_UPDATE_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  emailrequesting: false,
  specilitys: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SPECILITY_BY_ID_REQUEST:
      return {
        ...initialState,
        requesting: false,
      };

    case SPECILITY_BY_ID_SUCCESS:
      console.log(action.authData);
      return {
        ...state,
        requesting: false,
        specilitys: action.authData.name,
      };

    case SPECILITY_BY_ID_ERROR:
      return {
        ...initialState,
        requesting: false,
        error: JSON.parse(action.error),
      };
    case UPDATE_REQUEST:
      return {
        ...state,
        requesting: true,
      };

    case UPDATE_SUCCESS:
      return {
        ...state,
        requesting: false,
      };

    case UPDATE_ERROR: {
      return {
        ...state,
        requesting: false,
        error: JSON.parse(action.error),
      };
    }
    case EMAIL_UPDATE_REQUEST:
      return {
        ...state,
        emailrequesting: true,
      };

    case EMAIL_UPDATE_SUCCESS:
      return {
        ...state,
        emailrequesting: false,
      };

    case EMAIL_UPDATE_ERROR: {
      return {
        ...state,
        emailrequesting: false,
        error: JSON.parse(action.error),
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/userprofile/reducer.js